import { connectHook } from 'app/common/components/connect-hook';
import { Locales } from './locales.js';
import { useLocales } from './locales-hook.js';

export default connectHook(Locales, useLocales);
